import { Translation } from './Translation';

/**
 * IMPORTANT: Use this translation file as template for translators!
 *
 * Translator comments are only included here
 */
export const en_US: Translation = {
  translation: {
    placeholders: {
      notApplicable: 'Not applicable',
      placeholder: 'Placeholder',
      dropdownDefault: 'Select',
      typeToFilter: 'Type to filter',
      typeToSearch: 'Type to search',
      textareaDefault: 'Enter here',
    },
    errors: {
      textLimit:
        'You have exceeded the permitted character count. Please reduce the number of characters in order to proceed with your briefing.',
    },
    labels: {
      eLab: 'Azelis e-Lab',
      additionalInfo:
        'Notes (e.g. Benchmark, deadline, other target countries, ...)',
      price: 'e.g. 2.50 – 2.89 {{currency}}/{{weightUnit}}',
      targetPackaging: 'Target packaging',
      notes: 'Notes',
      attachments: 'Attachments',
      enterAName: 'Enter a name',
      addAttachment: 'Add attachment',
      optional: 'Optional',
      loading: 'Loading',
      briefing: {
        sent: 'Briefing sent',
        delivered: 'Briefing delivered',
      },
      signIn: 'Sign in',
      signOut: 'Sign out',
      requestAccess: 'Request access',
      multiSelectHint: 'Multiple selections possible',
      other: 'Other',
      noOptions: 'No options',
      or: 'or',
      // e.g. 'Created at 12:00am 12.12.2021'
      createdAt: 'Created at',
      createdBy: 'Created by',
      status: 'Status',
      continue: 'Continue',
      untitled: 'Untitled',
      countries: {
        Benelux: 'Benelux',
        Belgium: 'Belgium',
        France: 'France',
        Germany: 'Germany',
        India: 'India',
        Indonesia: 'Indonesia',
        Italy: 'Italy',
        Ireland: 'Ireland',
        Luxembourg: 'Luxembourg',
        Netherlands: 'Netherlands',
        'United Kingdom': 'United Kingdom',
      },
      languages: {
        de_DE: 'German',
        en_GB: 'English',
        en_US: 'English',
        fr_FR: 'French',
        zh_CN: 'Chinese',
        ko_KR: 'Korean',
      },
      countrySlug: {
        BNL: 'Benelux',
        FR: 'France',
        GB: 'United Kingdom',
        UK: 'United Kingdom',
        DE: 'Germany',
        IN: 'India',
        IT: 'Italy',
        ID: 'Indonesia',
        IE: 'Ireland',
      },
      markets: {
        AgriEnvironmental: 'Agricultural & Environmental Solutions',
        SpecialtyAgriHorti: 'Special Agricultural & Environmental Solutions',
        FoodNutrition: 'Food & Nutrition',
        FoodHealth: 'Food & Health',
        HomeCareIndustrialCleaning: 'Home Care & Industrial Cleaning',
        HomecareIndustrialCleaning: 'Home Care & Industrial Cleaning',
        PersonalCare: 'Personal Care',
      },
      ofTotal: 'of {{total}}',
      perPage: 'Per page:',
      briefingFlowTag: {
        base: 'base',
        colour: 'colour',
        fragrance: 'fragrance',
        formulation: 'formulation',
      },
    },
    linksOrButtons: {
      details: 'Details',
      // e.g. 'Back to Applications'
      backTo: 'Back to',
      seeProjectOverview: 'See project overview',
      backToOverview: 'Back to overview',
      backToReview: 'Jump to review',
      showMore: 'Show more',
      goToInspiration: 'Go to inspiration section',
      startNewFormulation: 'Start new formulation',
      toggleMenu: 'Toggle menu',
      navigation: {
        start: 'Start formulating',
        'project-overview': 'My formulations',
      },
      backToStart: 'Start',
      edit: 'Edit',
      next: 'Next',
      prev: 'Prev',
      sendBriefing: 'Send briefing',
    },
    topics: {
      application: {
        name: 'Applications',
        heading: {
          create: 'What is the product application and end use?',
          fix: 'What is the application of the formulation you want to fix?',
          enhance:
            'What is the application of the formulation you want to enhance?',
          modify: 'What is the product application and end use?',
        },
        levels: {
          '0': {
            normal: 'Main category',
            selected: 'Main category',
            other: 'Specify your selection',
            otherPlaceholder: 'New main category name',
            product: 'Product category',
          },
          '1': {
            normal: 'Choose a subcategory',
            selected: 'Subcategory',
            other: 'Specify your selection',
            otherPlaceholder: 'New subcategory name',
            technology: 'Technology',
          },
          '2': {
            normal: 'Choose one or more characteristics',
            selected: 'Characteristic',
            other: 'Specify your characteristic',
            otherPlaceholder: 'New characteristic name',
            endUse: 'End use',
            specifyEndUse: 'Specify your end use',
            endUsePlaceholder: 'End use name',
          },
        },
      },
      'formulation-attributes': {
        name: 'Formulation Attributes',
        heading: {
          general: 'Which formulation attributes should your product fulfill?',
        },
        productMarketingClaims: 'Product Marketing Claims',
        formulationType: 'Formulation type',
        texture: 'Texture',
        storage: 'Storage',
        productForm: 'Product Form',
        otherProductMarketingClaims: 'Specify other product marketing claims',
        otherFormulationType: 'Specify other formulation type',
        otherTexture: 'Specify other texture',
        otherStorage: 'Specify other storage',
        options: {
          availableProductMarketingClaims: {
            euEcolabel: 'EU Ecolabel',
            rspoCertified: 'RSPO Certified',
            bioBasedProduct: 'Bio-based product / natural derived',
            nordicSwan: 'Nordic Swan',
            euEcocert: 'EU Ecocert',
            lowCLP: 'Low CLP (classification)',
            lowToZeroVOC: 'Low to Zero VOC',
            biodegradable: '(Readily) biodegradable',
            lowAllergens: 'Low Allergens',
            highActive: 'High Active',
            nonLabelledForCLP: 'Non-Labelled for CLP',
            mildToSkinAndEyes: 'Mild to skin and eyes',
            easyToHandle: 'Easy to handle',
            highlyEffectiveLowDosageLevels:
              'Highly effective / low dosage levels',
            preservativeFree: 'Preservative free',
            foodContact: 'Food contact',
            noAnimalTesting: 'No animal testing',
            nanoparticlesFree: 'Nanoparticles free',
            lowSVHC: 'Low SVHC',
            natural: 'Natural',
            vegan: 'Vegan',
            noHeavyMetals: 'No heavy Metals',
            soothing: 'soothing',
            moisturising: 'moisturising',
            sensitiveSkin: 'sensitive skin',
            woundProtection: 'wound protection',
            calming: 'calming',
            waterSaving: 'water saving',
            antiageing: 'antiageing',
            softFocus: 'soft focus',
            wrinkleFilling: 'wrinkle filling',
            antiCreasing: 'anti-creasing',
            longLasting: 'long lasting',
            easyToApply: 'easy to apply',
            quickDrying: 'quick drying',
            waterProof: 'water-proof',
            highCoverage: 'high coverage',
            hydrating: 'hydrating',
            oilAbsorbing: 'oil absorbing',
            nonBleedingFeathering: 'non-bleeding/feathering',
            glossy: 'glossy',
            kissProof: 'kiss-proof',
            rubResistant: 'rub-resistant',
            removesWaterproof: 'removes waterproof',
            gentle: 'gentle',
            wearResistant: 'wear resistant',
            easyToRemove: 'easy to remove',
            highGlossShine: 'high gloss/shine',
            dermatologicallyTested: 'dermatologically tested',
            antibacterial: 'antibacterial',
            forSensitiveSkin: 'for sensitive skin',
            softening: 'softening',
            detangling: 'detangling',
            dryDamaged: 'dry/damaged',
            fineHair: 'fine hair',
            colourProtection: 'colour protection',
            colourEnhancing: 'colour enhancing',
            antiDandruff: 'anti dandruff',
            conditioning: 'conditioning',
            sulphateFree: 'sulphate free',
            antiBuildUp: 'anti build up',
            twoInOne: '2 in 1',
            permanent: 'permanent',
            semiPermanent: 'semi permanent',
            rootTouchUp: 'root touch up',
            temporary: 'temporary',
            treatment: 'treatment',
            hairStrengthening: 'hair strengthening',
            revitalising: 'revitalising',
            exfoliating: 'exfoliating',
            strengthening: 'strengthening',
            damageRepair: 'damage repair',
            thickening: 'thickening',
            protection: 'protection',
            protecting: 'protecting',
            strongHold: 'strong hold',
            improvedComfort: 'improved comfort',
            foodseal: 'foodseal',
            gumCare: 'gum care',
            whitening: 'whitening',
            alcoholFree: 'alcohol free',
            enamelCare: 'enamel care',
            sensitive: 'sensitive',
            antiseptic: 'antiseptic',
            antiBacterial: 'anti-bacterial',
            antiAgeing: 'anti-ageing',
            antioxidant: 'antioxidant',
            antiPollution: 'anti-pollution',
            repair: 'repair',
            skinTightening: 'skin tightening',
            illuminatingBrightning: 'illuminating/brightning',
            antiPuffinessDark: 'anti puffiness/-dark',
            cycles: 'cycles',
            purifying: 'purifying',
            oilControl: 'oil control',
            cooling: 'cooling',
            extraFirmHold: 'extra firm hold',
            firmHold: 'firm hold',
            lightHold: 'light hold',
            curlDefining: 'curl defining',
            volumising: 'volumising',
            mediumHold: 'medium hold',
            flexibleHold: 'flexible hold',
            shine: 'shine',
            weatherproof: 'weatherproof',
            uvProtection: 'UV protection',
            waterResistant: 'water resistant',
            floral: 'floral',
            fougère: 'fougère',
            aromatic: 'aromatic',
            woody: 'woody',
            citrus: 'citrus',
            amber: 'amber',
            chypre: 'chypre',
            fruity: 'fruity',
            gourmand: 'gourmand',
            musk: 'musk',
            spicy: 'spicy',
            cleanLabel: 'Clean label',
            naturalColours: 'Natural colours',
            naturalFlavours: 'Natural flavours',
            glutenFree: 'Gluten free',
            allergenFree: 'Allergen free',
            palmFree: 'Palm free',
            nanoFree: 'Nano free',
            noReducedFat: 'No / Reduced Fat',
            noReducedSugar: 'No / Reduced Sugar',
            noReducedSalt: 'No / Reduced Salt',
            sourceHighFiber: 'Source of / High in Fibre',
            sourceHighProtein: 'Source of / High in Protein',
            sourceHighVitaminsMinerals:
              'Source of / High in Vitamins and minerals',
            healthBenefices: 'Health benefices',
            veganVegetarianAnimalFree: 'Vegan / Vegetarian / Animal free',
            organic: 'Organic',
            fairTrade: 'Fair-trade',
            halal: 'Halal',
            kosher: 'Kosher',
            sweatReduction: 'Sweat reduction',
            odourProtection: 'Odor protection',
            aluminiumFree: 'Aluminum free',
            noWhitening: 'No whitening',
            invisible: 'Invisible',
            refreshing: 'Refreshing',
            moisturizing: 'Moisturizing',
          },
          availableFormulationTypes: {
            owEmulsion: 'O/W emulsion',
            woEmulsion: 'W/O emulsion',
            waterBased: 'Water based',
            oilBased: 'Oil based',
            emulsion: 'emulsion',
            anhydrous: 'anhydrous',
            alcoholic: 'alcoholic',
            nonAlcoholic: 'non alcoholic',
            other: 'Other',
            solidStick: 'solid stick',
            gelStick: 'gel stick',
            aerosolSpray: 'aerosol spray',
            nonAerosolSpray: 'non-aerosol spray',
            cream: 'cream',
            rollOn: 'roll-on',
            powder: 'powder',
          },
          availableTextures: {
            fluid: 'Fluid',
            spray: 'Spray',
            serum: 'Serum',
            aerosol: 'Aerosol',
            gel: 'Gel',
            lotion: 'Lotion',
            cream: 'Cream',
            solid: 'Solid',
            foam: 'Foam',
            powder: 'Powder',
            liquid: 'Liquid',
            tablet: 'Tablet',
            stick: 'Stick',
            bar: 'Bar',
            nonAerosol: 'Non Aerosol',
            other: 'Other',
            soft: 'Soft',
            emulsion: 'Emulsion',
          },
          availableStorage: {
            ambient: 'Ambient',
            bakeryDryBlend: 'Bakery blend / Dry blend',
            instantDryBlend: 'Instant (dry blend)',
            frozen: 'Frozen',
            bestBefore: '"Best Before"',
            pasteurisation: 'Pasteurisation',
            chilled: 'Chilled',
            bakeStability: 'Bake stability (microwave)',
          },
          availableProductForm: {
            powder: 'Powder',
            liquid: 'Liquid',
            granules: 'Granules',
            flakes: 'Flakes',
            paste: 'Paste',
            wax: 'Wax',
            prills: 'Prills',
            needles: 'Needles',
            piece: 'Piece',
            emulsion: 'Emulsion',
          },
        },
        errors: {
          productMarketingClaims: 'Error loading marketing claims',
        },
      },
      fragrance: {
        name: 'Fragrance',
        heading: {
          general: 'Fragrance your formulation',
        },
        fragranceFormulation:
          'Do you want to have your formulation fragranced?',
        attributesFulfill: 'Which attributes should your fragrance fulfill?',
        requirements:
          'Are there any requirements that the fragrance needs to comply to?',
        colourOrConcept: 'Concept / Colour',
        CMR: 'CMR (Carcinogenic, mutagenic and reprotoxic)',
        direction: 'Fragrance direction',
        mustComply: 'Fragrance must comply to',
        maxAllergensOnLabel: 'Max amount allergens on label',
        requestedApplicationDosage: 'Requested application dosage (in %)',
        fragranceSamples: 'Is there a need for fragrance samples?',
        requiredSampleTime: {
          heading: 'What is the required timing you need the sample by?',
          label: 'Required sample time',
        },
        largerFragranceSize: {
          heading:
            'Please specify if you need a larger fragrance sample size than 10gr per sample.',
          label: 'Larger sample size',
        },
        specifyFragranceMustOther: 'Specify other',
        options: {
          confirmFragranceOptions: {
            yes: 'Yes',
            no: 'No',
          },
          availableColoursOrConcepts: {
            black: 'Black',
            silver: 'Silver',
            white: 'White',
            blue: 'Blue',
            yellow: 'Yellow',
            pink: 'Pink',
            purple: 'Purple',
            green: 'Green',
            orange: 'Orange',
            gold: 'Gold',
            natural: 'Natural',
            clean: 'Clean',
            care: 'Care',
            hygiene: 'Hygiene',
            malodour: 'Malodour',
            performance: 'Performance',
            premium: 'Premium',
          },
          availableDirection: {
            citrus: 'Citrus',
            chypre: 'Chypre',
            floral: 'Floral',
            floriental: 'Floriental',
            fruity: 'Fruity',
            gourmand: 'Gourmand',
            green: 'Green',
            herbal: 'Herbal',
            lavender: 'Lavender',
            musk: 'Musk',
            oriental: 'Oriental',
            pine: 'Pine',
            spicy: 'Spicy',
            woody: 'Woody',
          },
          availableCMR: {
            notAllowed: 'Not allowed',
            allowedButOilNotLabelled: 'Allowed but oil not labelled CMR',
            allowed: 'Allowed',
          },
          mustComply: {
            noAllergensOnOil: 'No allergens on oil',
            noAllergensOnFinalProduct: 'No allergens on final product',
            pCMNMFree: 'PCM/NM free',
            ecoLabel: 'Ecolabel',
            okotestCandidate: 'Okotest candidate',
            vegan: 'Vegan',
            other: 'Other',
          },
        },
      },
      'processing-capabilities': {
        name: 'Processing Capabilities',
        heading: {
          general: 'What are the processing capabilities of your product?',
        },
        bakeStability: 'Bake stability',
        bakingTime: 'Baking time (minutes)',
        bakingTemperature: 'Baking temperature (°C)',
        fillingTime: 'Filling time (minutes)',
        fillingTemperature: 'Filling temperature (°C)',
        mixingStepDetails: 'Mixing steps details (high shear / paddle stirrer)',
        productPh: 'Product pH',
        brix: 'Brix (soluble solids)',
        processingCapabilitiesPackagingDetails:
          'Type and details about packaging',
        foodSafetyDetails: 'Food safety (Pasteurisation/UHT)',
        processingHotCold: 'Processing cold/hot',
        homogenisation: 'Homogenisation',
        otherProcessingCapabilities: 'Other processing capabilities',
      },
      restrictions: {
        name: 'Restrictions',
        heading: {
          general:
            'Are there any restrictions that the formulation needs to comply to?',
        },
        requirements: 'Requirements',
        restrictions: 'Restrictions',
        can: 'Can',
        must: 'Must',
        mustComply: 'Formulation must comply to',
        canComply: 'Formulation can comply to',
        requirementsMust: 'Requirements - Must',
        requirementsCan: 'Requirements - Can',
        restrictionsMust: 'Restrictions - Must',
        restrictionsCan: 'Restrictions - Can',
        specifyRequirements: 'Specify requirements',
        specifyRestrictions: 'Specify restrictions',
        options: {
          silictions: 'no silicones',
          parabens: 'no parabens',
          oil: 'no mineral oil based ingredients',
          emulsifier: 'emulsifier free',
          preservatives: 'no preservatives',
          ethanol: 'ethanol free',
          cold: 'cold production',
          polymore: 'synthetic polymer free',
          uv: 'no organic UV filters',
          nanomaterial: 'no nanomaterial',
          sulfate: 'sulfate-free',
          surfactant: 'low surfactant',
          tears: 'no tears formulation',
          talc: 'talc free',
          notApplicable: 'Not applicable',
          other: 'Other',
        },
        errors: {
          restrictions: 'Error loading restrictions',
        },
      },
      requirements: {
        name: 'Requirements',
        heading: {
          general:
            'Are there any requirements that the formulation needs to comply to?',
          specify: 'Please specify your further formulation requirements',
        },
        requirements: 'Requirements',
        can: 'Can',
        must: 'Must',
        mustComply: 'Formulation must comply to',
        canComply: 'Formulation can comply to',
        requirementsMust: 'Requirements - Must',
        requirementsCan: 'Requirements - Can',
        specifyRequirements: 'Specify requirements',
        applicationConditionDetails: {
          heading:
            'Please indicate details on the application conditions (Type of surface or soil, temperature range …).',
          label: 'Application condition details',
        },
        pHRange: {
          heading: 'In which pH range the product needs to be active?',
          label: 'phRange',
        },
        aggressiveComponents: {
          heading:
            'Please list the potential aggressive components in the formulation.',
          label: 'Aggressive components',
        },
        lightStability: {
          heading: 'Is light stability important?',
          label: 'Light stability',
          answer: {
            yes: 'Yes',
            no: 'No',
          },
        },
        options: {
          biodegradable: '(Readily) biodegradable',
          bioBased: 'Bio-based product / natural derived',
          carBody: 'Car body shop compliant',
          coldPress: 'Cold process',
          easyToHandle: 'Easy to handle',
          euEcocert: 'EU Ecocert',
          euEcolabel: 'EU Ecolabel',
          foodContact: 'Food contact',
          halal: 'Halal',
          highActive: 'High active',
          highlyEffectiveLowDosageLevels:
            'Highly effective / low dosage levels',
          kosher: 'Kosher',
          lowAllergens: 'Low Allergens',
          lowCLP: 'Low CLP (classification)',
          lowSVHC: 'Low SVHC',
          lowToZeroVOC: 'Low to Zero VOC',
          mildToSkinAndEyes: 'Mild to skin and eyes',
          nanoparticlesFree: 'Nanoparticles free',
          natural: 'Natural',
          noAnimalTesting: 'No animal testing',
          noHeavyMetals: 'No heavy metals',
          nonLabelledForCLP: 'Non-Labelled for CLP',
          nordicSwan: 'Nordic Swan',
          palmFree: 'Palm free',
          phosphorFree: 'Phosphor free',
          preservativeFree: 'Preservative free',
          rspoCertified: 'RSPO Certified',
          vegan: 'Vegan',
          notApplicable: 'Not applicable',
          other: 'Other',
        },
        errors: {
          requirements: 'Error loading requirements',
        },
      },
      colour: {
        name: 'Colour',
        heading: {
          general: 'Colour your formulation',
        },
        formulationColoured: 'Do you want to have your formulation coloured?',
        colourAttributes: 'Which attributes should your colourant fulfill?',
        colourShades: 'Colour Shades',
        colourSamples: {
          label: 'Colour samples',
          heading: 'Is there a need for colour samples?',
        },
        requiredTime: {
          heading: 'What is the required timing you need the sample by?',
          label: 'Required sample time',
        },
        labSupport: {
          heading: 'Do you require support from the Miliken lab? ',
          label: 'Support from the supplier lab required?',
        },
        options: {
          confirmColourOptions: {
            yes: 'Yes',
            no: 'No',
          },
          shades: {
            cyanBlue: 'Cyan Blue',
            royalBlue: 'Royal Blue',
            darkBlue: 'Dark Blue',
            brightBlue: 'Bright Blue',
            aquamarineBlue: 'Aquamarine Blue',
            brightGreen: 'Bright Green',
            green: 'Green',
            brightYellow: 'Bright Yellow',
            lemonYellow: 'Lemon Yellow',
            darkYellow: 'Dark Yellow',
            yellow: 'Yellow',
            orange: 'Orange',
            fluorescentYellow: 'Fluorescent Yellow',
            brightViolet: 'Bright Violet',
            purple: 'Purple',
            darkViolet: 'Dark Violet',
            darkRed: 'Dark red',
            fluorescentPink: 'Fluorescent Pink',
            brightPink: 'Bright Pink',
            softPink: 'Soft Pink',
          },
        },
      },
      'target-consumer': {
        name: 'Target Consumer',
        heading: {
          general: 'Who is your target consumer?',
        },
        age: 'Age',
        targetConsumerAge: 'Target Consumer Age',
        gender: 'Gender',
        targetConsumerGender: 'Target Consumer Gender',
        buttons: {
          genders: {
            female: 'Female',
            male: 'Male',
            allGenders: 'All genders',
          },
          allAges: 'All ages',
        },
      },
      'additional-info': {
        name: 'Additional Info',
        heading: {
          general: 'Do you have something more to add?',
        },
        additionalInfo: 'Additional Information',
        additionalInfoFiles: 'Additional Information Files',
      },
      price: {
        name: 'Price',
        heading: {
          general: 'What are your estimated formula costs?',
          base: 'What are your estimated base formulation costs?',
          color: 'What are your estimated additional colour costs?',
          fragrance: 'What are your estimated additional fragrance costs?',
        },
      },
      'product-details': {
        name: 'Product Details',
        heading: {
          general: 'Please specify your product details.',
        },
        finishedProductSamples: {
          heading: 'Is there a need for samples of the finished product?',
          answer: {
            yes: 'Yes',
            no: 'No',
          },
          requiredTimeForSample: 'If yes, required time for sample',
        },
        finishedProductPotential:
          'What is the finished product potential? (t/year)',
        projectDeadline: 'Project deadline',
      },
      packaging: {
        name: 'Packaging',
        heading: {
          general: 'What is your target packaging?',
        },
        options: {
          pumpDispenser: 'Pump dispenser',
          sprayDispenser: 'Spray dispenser',
          jar: 'Jar',
          tube: 'Tube',
          aerosol: 'Aerosol',
          sachet: 'Sachet',
          bagInCan: 'Bag-in-can',
          airPump: 'Air-pump',
          bag: 'Bag',
          carton: 'Carton',
          bottle: 'Bottle',
          compact: 'Compact',
          jarBottle: 'Jar-bottle',
          other: 'Other',
        },
      },
      'modification-type': {
        name: 'Modification Type',
        heading: {
          general: 'Which parts of your formulation do you want to modify?',
          type: 'Modification type',
        },
        options: {
          base: 'Modify base formulation',
          colour: 'Modify colour',
          fragrance: 'Modify fragrance',
        },
      },
      'modification-issue': {
        name: 'Modification',
        heading: {
          general: 'What is the modification you want to make?',
        },
        explainIssue: 'Please explain your issue',
      },
      problem: {
        name: 'Problem',
        fix: {
          name: 'Challenge',
        },
        enhance: { name: 'Enhancement' },
        heading: {
          fix: 'What is the challenge that you face with your formulation?',
          enhance: 'What enhancement do you want to make to your formulation?',
        },
      },
      ingredients: {
        name: 'Ingredients',
        heading: {
          general: 'Which ingredients do you currently use in the formulation?',
        },
        azelisRawMaterials: 'Azelis raw materials',
        rawMaterials: 'Raw materials',
        rawMaterial: 'Raw material',
        rawMaterialFiles: 'Raw materials Files',
        ingredientsFiles: 'Ingredients Files',
        upload: 'Upload your formulation here, or add raw materials below.',
        other: 'Raw materials (e.g. water, silica, caprylyl glycol, ...)',
      },
      'active-ingredients': {
        name: 'Active ingredients',
        heading: {
          general: 'What is the active ingredient of the formulation?',
        },
        chooseActiveIngredient: 'Choose active ingredient',
        concentration: 'Concentration [g/L]',
        addAnother: 'Add another active ingredient',
      },
      'active-function': {
        name: 'Active function',
        heading: {
          general:
            'Do you want to add further ingredients to your formulation?',
          review: 'Function',
        },
        adjuvant: {
          name: 'Adjuvant',
          choose: 'Choose adjuvant',
        },
        stabilizer: {
          name: 'Stabilizer',
          choose: 'Choose stabilizer',
        },
        emulsifier: {
          name: 'Emulsifier',
          choose: 'Choose emulsifier',
        },
        liquidColorant: {
          name: 'Liquid colorant',
          choose: 'Choose liquid colorant',
        },
        solvent: {
          name: 'Solvent',
          choose: 'Choose solvent',
        },
      },
      formulations: {
        name: 'Formulations',
      },
      review: {
        name: 'Review',
      },
    },
    modals: {
      cancelBriefing: {
        prompt: 'Do you want to cancel the briefing?',
        content: 'All existing input will be lost.',
        confirm: 'Yes',
        cancel: 'No',
      },
      customerSelection: {
        prompt: 'Specify user',
        content:
          'Please choose the customer and the customer user you are formulating for',
        form: {
          customer: 'Customer',
          customerUser: 'Customer user',
        },
        confirm: 'Confirm',
        cancel: 'Cancel',
        footer:
          'If you want to leave the Azelis e-Lab, you can <link1 label="sign out here" /> or visit the <link2 label="Azelis Customer Portal" />',
        error: {
          heading: 'Something went wrong',
          messages: {
            loadingCustomer: 'We were unable to load customer options.',
            loadingCustomerUser:
              'We were unable to load users for this customer.',
            settingCustomerUser:
              'There was a problem loading the user profile for this user.',
          },
          content:
            'Please try again. If the problem continues, please try to sign out and sign in again or <link1 label="contact Azelis support" />.',
          confirm: 'Try again',
          cancel: 'Sign out and try again',
          cannotSelectEmployeeUsers:
            'It is not possible to choose employee users',
        },
      },
      changeCustomerSelection: {
        change: 'Change',
        prompt: 'Do you want to change the user you are acting as?',
        confirm: 'Yes, change',
        cancel: 'Continue',
      },
      deleteUploadedFile: {
        prompt: 'Do you want to delete the file?',
        confirm: 'Yes, delete',
        cancel: 'Cancel',
      },
    },
    components: {
      briefingSelection: {
        heading: 'How do you want to start?',
        buttons: {
          create: {
            title: 'Create',
            copy: 'a new formulation',
          },
          enhance: {
            title: 'Enhance',
            copy: 'an existing formulation',
          },
          modify: {
            title: 'Modify',
            copy: 'an existing formulation',
          },
          fix: {
            title: 'Fix',
            copy: 'an existing formulation',
          },
        },
        inspirationLink: 'Get inspired by existing formulations',
        loading: 'Please wait while we are loading the necessary data',
      },
      stepPackaging: {
        packagingSamplePrompt:
          'If you have your packaging at disposal, please send it to us so that we can optimize the formulation to your needs. Please include your name and the project name so that we can match it to your brief.',
        addressLabel: 'Address',
        otherPackaging: 'Specify other packaging',
      },
      review: {
        heading: 'Review',
        productName: 'My project name',
      },
      success: {
        // The \n here creates a new line, and should not be translated
        heading: 'Thank you! \n Inquiry sent successfully.',
        emailInfo: 'A summary has been sent to your e-mail address.',
        whatsNext: {
          heading: 'What’s next?',
          review: 'Your briefing will be reviewed by our expert.',
          contact: 'Your account manager will contact you soon.',
        },
        recommendations: {
          heading: 'Need more inspiration?',
          subheading:
            'Here are a few more formulations and ingredients that match your application:',
          noDescription: 'No description',
        },
      },
      projectOverview: {
        heading: 'Formulations Overview',
        emptyFormulations: "It seems you don't yet have any formulations",
        createFormulation: 'Create formulation',
        myFormulations: 'My Formulations',
        // {{team}} = customer name or translation from 'team' below
        teamFormulations: '{{team}} Formulations',
        team: 'Team',
        filter: {
          country: 'Filter by country',
          market: 'Filter by market',
          application: 'Filter by application',
        },
        resetAllFilters: 'Clear all filters',
      },
      projectDetails: {
        projectType: {
          heading: 'Project Type',
          create: 'Create new formulation',
          enhance: 'Enhance an existing formulation',
          fix: 'Fix an existing formulation',
        },
        referenceId: 'Reference ID',
        formulationSpecifics: 'Formulation specifics',
        fileDownloadHelp:
          'If the file opens in a new tab, use ctrl + s (on Windows) or cmd + s (on Mac) to save the file',
      },
      account: {
        heading: 'Your Account',
        name: 'Name',
        email: 'Email address',
        selectedMarket: 'Selected market',
      },
      fileUpload: {
        fileListLabel: 'Files attached',
        privacy:
          'Your data uploads are completely safe and will not be shared with any third parties. They will only be used by Azelis in the project context to assure the best outcomes for you.',
      },
      customerSelectionBar: {
        onBehalf: 'You are formulating on behalf of:',
      },
      intro: {
        heading: {
          main: 'Easy access to all of our technical expertise with the new Azelis e-Lab.',
          about: 'About the e-Lab',
        },
        content: {
          main: 'The new e-Lab by Azelis is the smartest way to create new formulations, or to enhance existing ones. Get directly in touch with our experts and shorten your go-to-market process!',
          benefits: [
            'Fix or enhance an existing formulation',
            'Create new innovative formulations',
            'Get directly in touch with Azelis technical experts',
            'Accessible 24/7',
            'Get started now!',
          ],
        },
      },
      signIn: {
        passwordLabel: 'Password',
        email: 'Email Address',
        // $t(labels:requestAccess) = 'Request access', from the further up translation string
        signUp: 'Don’t have an account? $t(labels:requestAccess)!',
        loginWithCustomerPortal: 'Login with Customer Portal',
        pleaseWait: 'Please wait while we sign you in.',
        errors: {
          errorEmpty: 'Please enter an email and password',
          errorIncorrect:
            'The combination of the entered email and password is incorrect.',
          errorServerside: 'An error occurred, please try again later...',
          errorCustomerPortalLogin:
            'We were unable to access your Customer Portal profile.',
          access_denied:
            'It seems like permission was denied. Please try again.',
        },
      },
      footer: {
        partOfAzelis: 'Part of the Azelis Customer Portal',
        copyright: 'Copyright © Azelis {{year}}. All rights reserved.',
        links: {
          cookie: 'Cookie statement',
          privacy: 'Privacy statement',
          terms: 'Terms of Use',
        },
      },
      countryMarketSelector: {
        reason: {
          empty: {
            heading: 'No country or market selected',
            body: "You don't yet have a country or market selected. Please select one from the available options below:",
            universalCustomer: {
              heading: 'No customer, country or market selected',
              body: 'You don’t yet have a customer, country or market selected. Please select one from the available options below:',
            },
          },
          invalid: {
            heading: 'Invalid country or market selected',
            body: 'Your selected country or market is invalid. Please select one from the available options below:',
            universalCustomer: {
              heading: 'Invalid selection',
              body: 'Your selected customer, country or market is invalid. Please select one from the available options below:',
            },
          },
          preferences: {
            heading: 'Preferences',
            body: 'Please keep in mind that changing your preferences will impact the content that becomes available to you.',
          },
        },
        customer: 'Company',
        country: 'Country',
        market: 'Market',
        preferredLanguage: 'Preferred Language',
        confirm: 'Confirm',
        cancel: 'Cancel',
      },
      error404: {
        heading: 'Page not found',
        body: "We couldn't find anything at that URL. Try navigating using the menu or double-checking your link.",
      },
      noCountryMarketAvailable: {
        heading: 'No valid country or market found',
        body: "Your user profile doesn't seem to be associated with any country/market segments supported by e-Lab. Please contact your system administrator.",
      },
      filters: {
        filter: 'Filter',
      },
    },
    emails: {
      customer: {
        subject: 'Azelis e-Lab formulation briefing received',
        html: {
          introNotCreatedByEmployee:
            // {{branch}} = 'create', 'fix' or 'enhance'
            // {{branchFormulationPrefix}} = 'a new' or 'an existing'
            'Thank you! Your briefing to {{branch}} {{branchFormulationPrefix}} has been successfully sent to the Azelis technical experts.',
          introCreatedByEmployee:
            // Same as above
            '{{employeeCreatorName}} created a briefing on your behalf to {{branch}} {{branchFormulationPrefix}}. It has been successfully sent to the Azelis technical experts.',
          newFormulationPrefix: 'a new formulation',
          existingFormulationPrefix: 'an existing formulation',
          heading: 'A new briefing was created on the e-Lab',
          // {{customerName}} = e.g 'John Smith'
          line1: 'Dear {{customerName}},',
          line2:
            'Our expert team will now review your briefing and will soon be in touch with you.',
          line3:
            'Below, you can find a summary of the information that has been provided to us.',
          referenceId: 'Reference Id',
          projectName: 'Project Name',
          marketSegment: 'Market Segment',
          country: 'Country',
          thankYou: 'Thank you for using the Azelis e-Lab.',
          inspirationLinkText: 'Inspiration',
          inspirationSuggestion:
            // {{inspirationLink}} = just the word 'inspiration', but it's a link
            'If you don’t want to miss out on the latest trends in your industry and new market insights from our Azelis experts, make sure to visit our {{- inspirationLink}} section.',
          theAzelisTeam: 'The Azelis team',
          copyright: 'Copyright © Azelis {{year}}. All rights reserved.',
        },
      },
      lab: {
        // {{byDisplayName}} = either 'John Smith' or 'John Smith for Sam Samson'
        subject: 'Azelis e-Lab formulation briefing by {{byDisplayName}}',
        // {{byMe}} and {{forMe}} are both just names
        byFor: '{{byMe}} for {{forMe}}',
        html: {
          line1:
            // {{branch}} = 'create', 'fix' or 'enhance'
            // {{branchFormulationPrefix}} = 'a new' or 'an existing'
            // {{byDisplayName}} = same as above
            'A new briefing to {{branch}} {{branchFormulationPrefix}} was posted by {{byDisplayName}} on the Azelis e-Lab.',
          referenceId: 'Reference Id:',
          createdAt: 'Created at:',
          projectName: 'Project Name:',
          pleaseContact:
            // {{- mailToLink}} = an email address, but it's also a link
            'Please contact {{- mailToLink}} to discuss further details.',
          unnamedProject: 'Unnamed project',
          yourAzelisTeam: 'Your Azelis e-Lab Team',
        },
      },
      auxiliary: {
        // will be inserted for {{branch}} in the emails section
        branch: {
          create: 'create',
          enhance: 'enhance',
          modify: 'modify',
          fix: 'fix',
        },
      },
    },
  },
};
